import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-2xl w-full h-full aspect-square m-auto bg-gray-700 rounded-md animate-pulse -mb-6 sm:-mb-8"
}
const _hoisted_2 = {
  key: 1,
  class: "min-w-[8rem] min-h-[8rem] aspect-square relative"
}
const _hoisted_3 = { class: "bg-gray-700 object-cover rounded-md shadow-xl drop-shadow-lg absolute top-0 right-0 z-20 w-full h-full" }
const _hoisted_4 = ["href", "target", "onclick"]
const _hoisted_5 = {
  key: 0,
  class: "bg-gray-700 object-cover rounded-md shadow-xl drop-shadow-lg absolute top-0 right-0 z-20 w-full h-full"
}

import { DocumentViewMode } from '@/model/universal';
import LoadingSkeleton from './LoadingSkeleton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCard',
  props: {
    isLoading: { type: Boolean },
    viewMode: {},
    link: {},
    clickable: { type: Boolean },
    target: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading && _ctx.viewMode === _unref(DocumentViewMode).List)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingSkeleton, {
            isLoading: _ctx.isLoading,
            link: _ctx.link,
            target: _ctx.target
          }, null, 8, ["isLoading", "link", "target"])
        ]))
      : (!_ctx.link && _ctx.isLoading && _ctx.viewMode !== _unref(DocumentViewMode).List)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LoadingSkeleton, {
                isLoading: _ctx.isLoading,
                link: _ctx.link,
                target: _ctx.target
              }, null, 8, ["isLoading", "link", "target"])
            ])
          ]))
        : _createCommentVNode("", true),
    (_ctx.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: _ctx.link,
          disabled: "",
          target: _ctx.target,
          rel: "noopener noreferrer",
          class: _normalizeClass(
			(_ctx.viewMode !== _unref(DocumentViewMode).List
				? 'min-w-[8rem] min-h-[8rem] aspect-square'
				: 'w-fit m-auto') + ' relative'
		),
          onclick: () => _ctx.clickable
        }, [
          (_ctx.isLoading && _ctx.viewMode !== _unref(DocumentViewMode).List)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(LoadingSkeleton, {
                  isLoading: _ctx.isLoading,
                  link: _ctx.link,
                  target: _ctx.target
                }, null, 8, ["isLoading", "link", "target"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})